<template>
  <div id="tuitionVbar"/>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  data: Object,
  year: Number,
})

onMounted(() => {
  const { data, year } = props

  const series = Object.values(data).map(item => {
    return {
      ...item,
      name: item.title,
      marker: {
        symbol: "circle",
      },
    }
  })

  const options = {
    chart: {
      type: "scatter",
      zoomType: "xy",
      height: 500,
    },
    title: {
      text: `Full-Time Net Tuition ${year}-${year + 1} vs Bar Pass Rates for ${year} Graduates`,
    },
    xAxis: {
      title: {
        enabled: true,
        text: `Bar Passage Rate in ${year}`,
      },

      startOnTick: true,
      endOnTick: true,
      tickInterval: 5,
      showLastLabel: true,
      ceiling: 100,
      max: 100,
      min: 30,
      floor: 30,
      labels: {
        formatter() {
          return `${this.value}%`
        },
      },
    },
    yAxis: {
      title: {
        text: `Net Tuition in ${year}-${year + 1}`,
      }, min: 0, max: 60000,
      labels: {
        formatter() {
          return `$${Math.round(this.value / 1000)}k`
        },
      },
      endOnTick: false,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      formatter() {
        return `<b> ${this.point.name} </b><br>Net Tuition: $${Math.round(this.y / 1000)}k<br>Bar Pass Rate: ${this.x}%`
      },
    },
    series,
  }
  new Highcharts.chart("tuitionVbar", options)
})
</script>
